import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  LinearProgress,
  Alert,
  CircularProgress
} from '@mui/material';
import VideoUpload from '../components/VideoUpload';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const UploadPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const selectedFile = location.state?.selectedFile;

  useEffect(() => {
    console.log('📤 UploadPage 已載入');
    console.log('📍 當前路徑:', location.pathname);
    console.log('📦 location.state:', location.state);
    
    // 🔧 修復：如果有選中的檔案，記錄日誌
    if (selectedFile) {
      console.log('🔍 UploadPage: 檢測到選中檔案，準備自動上傳:', selectedFile.name);
    }
  }, [location, selectedFile]);

  const handleBack = () => {
    navigate('/open');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', p: 3 }}>
      <Box sx={{ maxWidth: '1200px', mx: 'auto' }}>
        {/* 返回按鈕 */}
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          sx={{ mb: 3 }}
        >
          返回
        </Button>

        {/* 標題 */}
        <Typography variant="h4" sx={{ mb: 4 }}>
          上傳影片到雲端
        </Typography>

        {/* 錯誤提示 */}
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {/* 上傳組件 */}
        <VideoUpload
          initialFile={selectedFile} // 🔧 新增：傳遞選中的檔案
          autoUpload={!!selectedFile} // 🔧 新增：如果有選中檔案則自動上傳
          onUploadSuccess={(result) => {
            console.log('✅ 上傳成功:', result);
            setError(null);
            // 可以導航到主頁面或顯示成功訊息
            alert('上傳成功！');
            navigate('/manage');
          }}
          onUploadError={(errorMsg) => {
            console.error('❌ 上傳失敗:', errorMsg);
            setError(errorMsg);
          }}
        />
      </Box>
    </Box>
  );
};

export default UploadPage;

